import {
  FooterCountryWrapper,
  FooterCountryContainer,
  FooterCountryLogo,
  FooterCountryText,
  FooterSelectCountryText,
  FooterCountrySelectionContainer
} from "./FooterCountryStyled";
import Thailand from "../../../../../Assets/Image/Footer/Thailand.svg";
import GlobalLogo from "../../../../../Assets/Image/Footer/GlobalLogo.svg";
import { useState } from "react";

const FooterCountry = () => {
  const [coutry, setCountry] = useState("english");

  return (
    <FooterCountryWrapper>
      <FooterCountryContainer>
        <FooterCountryLogo src={Thailand} />
        <FooterCountryText>THAILAND</FooterCountryText>
      </FooterCountryContainer>
      <FooterCountrySelectionContainer width="186px">
        <FooterCountryLogo width="15px" height="15px" src={GlobalLogo} />
        <FooterCountryText>
          <FooterSelectCountryText
            onClick={() => setCountry("thai")}
            color={coutry === "thai" ? "#FFFFFF" : "#9EA9B9"}
          >
            ภาษาไทย
          </FooterSelectCountryText>
          <FooterSelectCountryText> | </FooterSelectCountryText>
          <FooterSelectCountryText
            onClick={() => setCountry("english")}
            color={coutry === "english" ? "#FFFFFF" : "#9EA9B9"}
          >
            English
          </FooterSelectCountryText>
        </FooterCountryText>
      </FooterCountrySelectionContainer>
    </FooterCountryWrapper>
  );
};

export default FooterCountry;
